var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.queries)?_c('div',[_c('ul',{staticClass:"list-group"},_vm._l((_vm.queries),function(query){return _c('li',{staticClass:"list-group-item mb-2",class:_vm.status(query),on:{"click":function($event){return _vm.changeActive(query.id)}}},[_c('query-card-component',{key:query.id,attrs:{"query":query}})],1)}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }